import React from "react";
// import ApplicationUnderProcess from "./components/ApplicationUnderProcess";
import Dashboard from "./components/Dashboard";

// type DashBoardProps = {
// 	isApplicationUnderProcess: boolean;
// };

const Home: React.FC = (props) => {
	return <Dashboard />;
};

export default Home;
